export enum ShapefileRegion {
  US = 'US',
  CANADA = 'CANADA',
}

export enum EShapeFileType {
  PLAY = 'play',
  OPERATOR = 'operator',
}

const enum EDownloadDataSource {
  ALL_US_DATA = 'ALL_US_DATA.zip',
  ALL_CAN_DATA = 'ALL_CAN_DATA.zip',
}

export const getAllRegionsFileByCountry = (country: ShapefileRegion | null) =>
  country ? (country === ShapefileRegion.US ? EDownloadDataSource.ALL_US_DATA : EDownloadDataSource.ALL_CAN_DATA) : '';
